/**
 * One server-sent event block, parsed (chat-relay-thread D12). Pure, shared by every chat event
 * stream: the admin's, the Mini App client's and the website's (web-account-pages D1).
 */
export interface ThreadStreamEvent {
  event: string;
  data: string;
}

/** One event-stream block. Comment lines (the heartbeat) dispatch nothing. */
export function parseEventBlock(block: string): ThreadStreamEvent | null {
  let event = 'message';
  const data: string[] = [];
  for (const line of block.split('\n')) {
    if (!line || line.startsWith(':')) continue;
    const colon = line.indexOf(':');
    const field = colon === -1 ? line : line.slice(0, colon);
    const value = colon === -1 ? '' : line.slice(colon + 1).replace(/^ /, '');
    if (field === 'event') event = value;
    else if (field === 'data') data.push(value);
  }
  return data.length > 0 ? { event, data: data.join('\n') } : null;
}
